import { SET_SELECTED_PAYEE, SET_EDIT_PAYEE_FLAG, RESET_MANAGE_PAYEE, SET_PAYEE_TYPE } from './action';
import { START_BATCH_PROCESS, STOP_BATCH_PROCESS, UPDATE_BATCH_PROGRESS } from '../../states/api/chunkingActions';
import { GO_TO_EDIT_PAYEE_PAGE } from '../../states/api/fasterPaymentActions';
import { TYPE_DOMESTIC_PAYEE } from '../../config';

export const initialState = {
	payeeType: TYPE_DOMESTIC_PAYEE,
	isProcessingBatch: false,
	numberOfItemsInBatch: undefined,
	currentBatchSize: undefined,
	currentBatchProgress: undefined,
	selectedPayee: {},
};

const managePayee = (state = initialState, action) => {
	switch (action.type) {
		case SET_SELECTED_PAYEE: {
			return {
				...state,
				selectedPayee: action.selectedPayee,
			};
		}
		case SET_EDIT_PAYEE_FLAG: {
			return {
				...state,
				isEditPayeeFlag: true,
			};
		}
		case RESET_MANAGE_PAYEE: {
			return { ...initialState, payeeType: state.payeeType };
		}
		case SET_PAYEE_TYPE: {
			return {
				...state,
				payeeType: action.payeeType,
			};
		}

		case START_BATCH_PROCESS:
			return {
				...state,
				isProcessingBatch: true,
				numberOfItemsInBatch: action.payload.numberOfItems,
			};

		case STOP_BATCH_PROCESS:
			return {
				...state,
				isProcessingBatch: false,
				currentBatchSize: undefined,
				currentBatchProgress: undefined,
				numberOfItemsInBatch: undefined,
			};

		case UPDATE_BATCH_PROGRESS:
			return {
				...state,
				currentBatchSize: action.payload.total,
				currentBatchProgress: action.payload.completed,
			};
		case GO_TO_EDIT_PAYEE_PAGE:
			return {
				...state,
				isCOPEdit: action.payload.isCOPEdit,
			};

		default:
			return state;
	}
};

export default managePayee;
